import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks'

export const TimeTrackingApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.TIMETRACKING}
      scope='timetracking'
      envKey={apps[AppId.TIMETRACKING].runtimeEnvKey}
      entryPath='./TimetrackingApp'
      url={process.env.REACT_APP_TIMETRACKING_APP_DEV_PATH}
      appName={apps[AppId.TIMETRACKING].name}
      appProps={{
        user,
        initialPath: location.pathname,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        },
        isWidget: false
      }}
    />
  )
}
